import { PasswordStrengthMeter } from '@src/components/ui';

import useFormContext from './useFormContext';


/** Reads the watched password field from the generic form and renders the meter. */
function PasswordStrength(props) {
  const { name = 'password', className } = props;
  const { watch } = useFormContext();
  return <PasswordStrengthMeter className={className} value={watch(name) || ''} />;
}

PasswordStrength.displayName = 'PasswordStrength(Generic)';
export default PasswordStrength;
